module.exports = __webpack_public_path__ + "img/ic_32_gender_man-active.2d3e18b8.svg";